import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from '@ohif/ui';

// Route Components — lazy-loaded so viewer-only visits skip WorkList bundle
const DataSourceWrapper = React.lazy(() => import('./DataSourceWrapper'));
const WorkList = React.lazy(() => import('./WorkList'));
const Local = React.lazy(() => import('./Local'));
const Debug = React.lazy(() => import('./Debug'));
import NotFound from './NotFound';

const createLocalRoute = modePath => function LocalRoute(props) {
  return <Local modePath={modePath} {...props} />;
};
import buildModeRoutes from './buildModeRoutes';
import PrivateRoute from './PrivateRoute';
import PropTypes from 'prop-types';
import { FcExpired } from "react-icons/fc";
// import { Link } from 'react-router-dom';

const NotFoundServer = ({
  message = 'Unable to query for studies at this time. Check your data source configuration or network connection',
}) => {
  return (
    <div className="absolute flex h-full w-full items-center justify-center text-white">
      <div>
        <h4>{message}</h4>
      </div>
    </div>
  );
};

NotFoundServer.propTypes = {
  message: PropTypes.string,
};

const NotFoundStudy = () => {
  return (
    <div className="absolute flex h-full w-full items-center justify-center text-white">
      <h4>Study is&nbsp;<span className='text-primary-light'>Not Found..!!!</span></h4>
      {/* <Link to="/" className="ml-2 text-primary-light underline">&nbsp;Go to Worklist</Link> */}
    </div>
  );
};

NotFoundStudy.propTypes = {
  message: PropTypes.string,
};

// const LinkExpired = () => {
//   return (
//     <div className="absolute flex h-full w-full items-center justify-center text-white">
//       <h4>Link Expired</h4>
//     </div>
//   );
// };

// const LinkExpired = () => {
//   return (
//     <div className="flex h-screen w-full flex-col items-center justify-center bg-gray-900 text-white px-6">
//       <div className="bg-gray-800 shadow-xl rounded-2xl p-8 text-center max-w-md w-full border border-gray-700">
//         {/* Icon */}
//         <div className="flex justify-center mb-4">
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="h-16 w-16 text-red-500 animate-pulse"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//             strokeWidth="1.5"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               d="M12 9v4m0 4h.01M4.93 4.93l14.14 14.14M12 3C7.03 3 3 7.03 3 12s4.03 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61L4.93 4.93z"
//             />
//           </svg>
//         </div>

//         {/* Title */}
//         <h1 className="text-2xl font-bold mb-2 text-red-400">
//           Link Expired
//         </h1>

//         {/* Message */}
//         <p className="text-gray-400 mb-6">
//           This link has expired or is no longer valid.
//           Please request a new one from the sender or return to the main page.
//         </p>

//         {/* Action Button */}
//         <Link
//           to="/"
//           className="inline-block bg-primary-light hover:bg-primary-dark text-white font-semibold py-2 px-6 rounded-lg transition-all duration-300"
//         >
//           Go to Worklist
//         </Link>
//       </div>
//     </div>
//   );
// };

const LinkExpired = () => {
  return (
    <div className="flex h-screen w-full flex-col items-center justify-center bg-gray-900 text-white px-6 overflow-hidden relative">
      {/* Floating background effects */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute bg-red-500 opacity-10 w-32 h-32 rounded-full top-10 left-20 animate-floating"></div>
        <div className="absolute bg-blue-500 opacity-10 w-40 h-40 rounded-full bottom-10 right-24 animate-floating-delayed"></div>
      </div>

      {/* Main Card */}
      <div className="bg-gray-800 shadow-2xl rounded-2xl p-8 text-center max-w-md w-full border border-gray-700 transform transition-all duration-700 animate-fadeInUp relative z-10 animate-bounce-slow">
        {/* Icon */}
        <div className="flex justify-center mb-4 animate-bounce-slow">
          <FcExpired className="h-16 w-16 text-red-500" />
        </div>

        {/* Title */}
        <h1 className="text-3xl font-extrabold mb-2 text-red-400 animate-fadeIn animate-bounce-slow">
          Link Expired
        </h1>

        {/* Message */}
        <p className="text-gray-400 mb-6 animate-fadeInSlow animate-bounce-slow">
          This link has expired or is no longer valid.
          Please <b>request a new one</b> from the sender.
        </p>

        {/* Button */}
        {/* <Link
          to="/"
          className="inline-block bg-primary-light hover:bg-primary-dark text-white font-semibold py-2 px-6 rounded-lg transition-all duration-300 hover:scale-105 animate-fadeInUp"
        >
          Go to Worklist
        </Link> */}
      </div>

      {/* Inline animation styles */}
      <style>{`
        @keyframes fadeInUp {
          0% { opacity: 0; transform: translateY(40px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeIn {
          0% { opacity: 0; transform: translateY(-10px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes floating {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes bounceSlow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        .animate-fadeInUp { animation: fadeInUp 0.9s ease-out; }
        .animate-fadeIn { animation: fadeIn 1.2s ease-in-out; }
        .animate-fadeInSlow { animation: fadeIn 1.6s ease-in-out; }
        .animate-floating { animation: floating 6s ease-in-out infinite; }
        .animate-floating-delayed { animation: floating 8s ease-in-out infinite 2s; }
        .animate-bounce-slow { animation: bounceSlow 2s infinite; }
      `}</style>
    </div>
  );
};



LinkExpired.propTypes = {
  message: PropTypes.string,
};

// TODO: Include "routes" debug route if dev build
const bakedInRoutes = [
  {
    path: '/notfoundserver',
    children: NotFoundServer,
  },
  {
    path: '/notfoundstudy',
    children: NotFoundStudy,
  },
  {
    path: '/link-is-expired',
    children: LinkExpired,
  },
  {
    path: '/debug',
    children: Debug,
  },
  {
    path: '/local',
    // children: createLocalRoute(''),
    children: NotFound,
  },
  {
    path: '/localbasic',
    children: createLocalRoute('viewer/dicomlocal'),
  },
];

// NOT FOUND (404)
const notFoundRoute = { component: NotFound };

const createRoutes = ({
  modes,
  dataSources,
  extensionManager,
  servicesManager,
  commandsManager,
  hotkeysManager,
  routerBasename,
  showStudyList,
}: withAppTypes) => {
  const routes =
    buildModeRoutes({
      modes,
      dataSources,
      extensionManager,
      servicesManager,
      commandsManager,
      hotkeysManager,
    }) || [];

  const { customizationService } = servicesManager.services;

  const WorkListRoute = {
    path: '/',
    children: DataSourceWrapper,
    private: true,
    props: { children: WorkList, servicesManager, extensionManager },
  };

  const customRoutes = customizationService.getGlobalCustomization('customRoutes');
  const allRoutes = [
    ...routes,
    ...(showStudyList ? [WorkListRoute] : []),
    ...(customRoutes?.routes || []),
    ...bakedInRoutes,
  // Catch-all route for any undefined path
  { path: '*', children: NotFound },
    customRoutes?.notFoundRoute || notFoundRoute,
  ];

  function RouteWithErrorBoundary({ route, ...rest }) {
    const Child = route.children;
    // eslint-disable-next-line react/jsx-props-no-spreading
    return (
      <ErrorBoundary
        context={`Route ${route.path}`}
        fallbackRoute="/"
      >
        <Suspense fallback={null}>
          <Child
            {...rest}
            {...route.props}
            route={route}
            servicesManager={servicesManager}
            extensionManager={extensionManager}
            hotkeysManager={hotkeysManager}
          />
        </Suspense>
      </ErrorBoundary>
    );
  }

  const { userAuthenticationService } = servicesManager.services;

  // All routes are private by default and then we let the user auth service
  // to check if it is enabled or not
  // Todo: I think we can remove the second public return below
  return (
    <Routes>
      {allRoutes.map((route, i) => {
        return route.private === true ? (
          <Route
            key={i}
            path={route.path}
            element={
              <PrivateRoute
                handleUnauthenticated={() => userAuthenticationService.handleUnauthenticated()}
              >
                <RouteWithErrorBoundary route={route} />
              </PrivateRoute>
            }
          ></Route>
        ) : (
          <Route
            key={i}
            path={route.path}
            element={<RouteWithErrorBoundary route={route} />}
          />
        );
      })}
    </Routes>
  );
};

export default createRoutes;
